import { api } from './http';
import type { FeedbackItem } from './types';

export interface ListFeedbackParams {
  type?: string;
  status?: string;
  limit?: number;
  offset?: number;
}

export interface CreateFeedbackPayload {
  type: string;
  title: string;
  description?: string;
  page_url?: string;
}

export interface UpdateFeedbackPayload {
  status?: string;
  resolution_note?: string;
}

export const listFeedback = (params?: ListFeedbackParams) =>
  api.get<FeedbackItem[]>('/feedback', { params }).then(r => r.data);

export const createFeedback = (data: CreateFeedbackPayload, screenshot?: File) => {
  const formData = new FormData();
  formData.append('type', data.type);
  formData.append('title', data.title);
  if (data.description) formData.append('description', data.description);
  if (data.page_url) formData.append('page_url', data.page_url);
  if (screenshot) formData.append('screenshot', screenshot);

  return api.post<FeedbackItem>('/feedback', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};

export const updateFeedback = (id: number, data: UpdateFeedbackPayload) =>
  api.patch<FeedbackItem>(`/feedback/${id}`, data).then(r => r.data);

export const getFeedbackScreenshotUrl = (id: number) =>
  `/api/feedback/${id}/screenshot`;
